export const INCREMENT = "INCREMENT";
export const DECREMENT = "DECREMENT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const SUPERADMIN_LOGIN_SUCCESS = "SUPERADMIN_LOGIN_SUCCESS";
export const SUPERADMIN_LOGIN_FAIL = "SUPERADMIN_LOGIN_FAIL";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";
export const VALIDATESIGNUP_SUCCESS = "VALIDATESIGNUP_SUCCESS";
export const VALIDATESIGNUP_FAIL = "VALIDATESIGNUP_FAIL";
export const REFRESHTOKEN_SUCCESS = "VALIDATESIGNUP_SUCCESS";
export const REFRESHTOKEN_FAIL = "VALIDATESIGNUP_FAIL";
export const CHANGEPASSWORD_SUCCESS = "CHANGEPASSWORD_SUCCESS";
export const CHANGEPASSWORD_FAIL = "CHANGEPASSWORD_FAIL";
export const FORGOTPASSWORDACTION_SUCCESS = "FORGOTPASSWORDACTION_SUCCESS";
export const FORGOTPASSWORDACTION_FAIL = "FORGOTPASSWORDACTION_FAIL";
export const FORGOTPASSWORD_SUCCESS = "FORGOTPASSWORDACTION_SUCCESS";
export const FORGOTPASSWORD_FAIL = "FORGOTPASSWORDACTION_FAIL";
export const GETWORKSPACEDETAILS_SUCCESS = "GETWORKSPACEDETAILS_SUCCESS";
export const GETWORKSPACEDETAILS_FAIL = "GETWORKSPACEDETAILS_FAIL";
export const CREATEWORKSPACE_SUCCESS = "CREATEWORKSPACE_SUCCESS";
export const CREATEWORKSPACE_FAIL = "CREATEWORKSPACE_FAIL";
export const MONDAYWORKSPACE_SUCCESS = "MONDAYWORKSPACE_SUCCESS";
export const MONDAYWORKSPACE_FAIL = "MONDAYWORKSPACE_FAIL";
export const GETALLPLATFORM_SUCCESS = "GETALLPLATFORM_SUCCESS";
export const GETALLPLATFORM_FAIL = "GETALLPLATFORM_FAIL";
export const SEARCHWORKSPACE_SUCCESS = "SEARCHWORKSPACE_SUCCESS";
export const SEARCHWORKSPACE_FAIL = "SEARCHWORKSPACE_FAIL";
export const MANAGEWORKSPACE_SUCCESS = "MANAGEWORKSPACE_SUCCESS";
export const MANAGEWORKSPACE_FAIL = "MANAGEWORKSPACE_FAIL";
export const UPDATE_MEMBER_LANGUAGE_SUCCESS = "UPDATE_MEMBER_LANGUAGE_SUCCESS";
export const UPDATE_MEMBER_LANGUAGE_FAIL = "UPDATE_MEMBER_LANGUAGE_FAIL";
export const UPDATE_MEMBER_THEME_SUCCESS = "UPDATE_MEMBER_THEME_SUCCESS";
export const UPDATE_MEMBER_THEME_FAIL = "UPDATE_MEMBER_THEME_FAIL";
export const UPDATEWORKSPACE_SUCCESS = "UPDATEWORKSPACE_SUCCESS";
export const UPDATEWORKSPACE_FAIL = "UPDATEWORKSPACE_FAIL";
export const EDITUPDATEWORKSPACE_SUCCESS = "EDITUPDATEWORKSPACE_SUCCESS";
export const EDITUPDATEWORKSPACE_FAIL = "EDITUPDATEWORKSPACE_FAIL";
export const SEARCHCUSTOMER_SUCCESS = "SEARCHCUSTOMER_SUCCESS";
export const SEARCHCUSTOMER_FAIL = "SEARCHCUSTOMER_FAIL";
export const UPDATETEAMGROUP_SUCCESS = "UPDATETEAMGROUP_SUCCESS";
export const UPDATETEAMGROUP_FAIL = "UPDATETEAMGROUP_FAIL";
export const ADDCUSTOMER_SUCCESS = "ADDCUSTOMER_SUCCESS";
export const ADDCUSTOMER_FAIL = "ADDCUSTOMER_FAIL";
export const UPDATECUSTOMER_SUCCESS = "UPDATECUSTOMER_SUCCESS";
export const UPDATECUSTOMER_FAIL = "UPDATECUSTOMER_FAIL";
export const CREATEDEPARTMENT_SUCCESS = "CREATEDEPARTMENT_SUCCESS";
export const CREATEDEPARTMENT_FAIL = "CREATEDEPARTMENT_FAIL";
export const GETDEPARTMENTDETAILS_SUCCESS = "GETDEPARTMENTDETAILS_SUCCESS";
export const GETDEPARTMENTDETAILS_FAIL = "GETDEPARTMENTDETAILS_FAIL";
export const SEARCHDEPARTMENT_SUCCESS = "SEARCHWORKSPACE_SUCCESS";
export const SEARCHDEPARTMENT_FAIL = "SEARCHWORKSPACE_FAIL";
export const GETDEPARTMENT_HEAD_SUCCESS = "GETDEPARTMENT_HEAD_SUCCESS";
export const GETDEPARTMENT_HEAD_FAIL = "GETDEPARTMENT_HEAD_FAIL";
export const UPDATEDEPARTMENT_SUCCESS = "UPDATEDEPARTMENT_SUCCESS";
export const UPDATEDEPARTMENT_FAIL = "UPDATEDEPARTMENT_FAIL";
export const DELETEDEPARTMENT_SUCCESS = "DELETEDEPARTMENT_SUCCESS";
export const DELETEDEPARTMENT_FAIL = "DELETEDEPARTMENT_FAIL";
export const CREATEPROJECT_SUCCESS = "CREATEPROJECT_SUCCESS";
export const CREATEPROJECT_FAIL = "CREATEPROJECT_FAIL";
export const GETPROJECTHISTORY_SUCCESS = "GETPROJECTHISTORY_SUCCESS";
export const GETPROJECTHISTORY_FAIL = "GETPROJECTHISTORY_FAIL";
export const SUBMITFORTIMESHEETAPPROVAL_SUCCESS =
  "SUBMITFORTIMESHEETAPPROVAL_SUCCESS";
export const SUBMITFORTIMESHEETAPPROVAL_FAIL =
  "SUBMITFORTIMESHEETAPPROVAL_FAIL";
export const SEARCHPROJECT_SUCCESS = "SEARCHPROJECT_SUCCESS";
export const SEARCHPROJECT_FAIL = "SEARCHPROJECT_FAIL";
export const PROJECT_DATA = "PAYLOAD_DATA";
export const WORKSPACEID_DATA = "WORKSPACEID_DATA";
export const INVOICE_DATA = "INVOICE_DATA";
export const INVOICE_CUSTOMERID = "INVOICE_CUSTOMERID";
export const INVOICE_PROJECTID = "INVOICE_PROJECTID";
export const INVOICE_STATUS = "INVOICE_STATUS";
export const PROJECTSTATUS_SUCCESS = "PROJECTSTATUS_SUCCESS";
export const PROJECTSTATUS_FAIL = "PROJECTSTATUS_FAIL";
export const PROJECTTASKSTATUS_SUCCESS = "PROJECTTASKSTATUS_SUCCESS";
export const PROJECTTASKSTATUS_FAIL = "PROJECTTASKSTATUS_FAIL";
export const CREATETEAM_SUCCESS = "CREATETEAM_SUCCESS";
export const CREATETEAM_FAIL = "CREATETEAM_FAIL";
export const SEARCHTEAM_SUCCESS = "SEARCHTEAM_SUCCESS";
export const SEARCHTEAM_FAIL = "SEARCHTEAM_FAIL";
export const CREATETASK_SUCCESS = "CREATETASK_SUCCESS";
export const CREATETASK_FAIL = "CREATETASK_FAIL";
export const SEARCHTASK_SUCCESS = "SEARCHTASK_SUCCESS";
export const SEARCHTASK_FAIL = "SEARCHTASK_FAIL";
export const ADDMEMBER_SUCCESS = "ADDMEMBER_SUCCESS";
export const ADDMEMBER_FAIL = "ADDMEMBER_FAIL";
export const ADD_MEMBER_BY_LINK_SUCCESS = "ADD_MEMBER_BY_LINK_SUCCESS";
export const ADD_MEMBER_BY_LINK_FAIL = "ADD_MEMBER_BY_LINK_FAIL";
export const SEARCHMEMBER_SUCCESS = "SEARCHMEMBER_SUCCESS";
export const SEARCHMEMBER_FAIL = "SEARCHMEMBER_FAIL";
export const PROJECTMEMBERLIST_SUCCESS = "PROJECTMEMBERLIST_SUCCESS";
export const PROJECTMEMBERLIST_FAIL = "PROJECTMEMBERLIST_FAIL";
export const MEMBERPROJECTS_SUCCESS = "MEMBERPROJECTS_SUCCESS";
export const MEMBERPROJECTS_FAIL = "MEMBERPROJECTS_FAIL";
export const MEMBERACCESS_SUCCESS = "MEMBERACCESS_SUCCESS";
export const MEMBERACCESS_FAIL = "MEMBERACCESS_FAIL";
export const MEMBERGROUPS_SUCCESS = "MEMBERGROUPS_SUCCESS";
export const MEMBERGROUPS_FAIL = "MEMBERPROJECTS_FAIL";
export const GETPROJECTDETAILS_SUCCESS = "GETPROJECTDETAILS_SUCCESS";
export const GETPROJECTDETAILS_FAIL = "GETPROJECTDETAILS_FAIL";
export const GETWORKSPACEMEMBER_SUCCESS = "GETWORKSPACEMEMBER_SUCCESS";
export const GETWORKSPACEMEMBER_FAIL = "GETWORKSPACEMEMBER_FAIL";
export const REMOVEMEMBER_SUCCESS = "REMOVEMEMBER_SUCCESS";
export const REMOVEMEMBER_FAIL = "REMOVEMEMBER_FAIL";
export const GETNONPROJECTMEMBER_SUCCESS = "GETNONPROJECTMEMBER_SUCCESS";
export const GETNONPROJECTMEMBER_FAIL = "GETNONPROJECTMEMBER_FAIL";
export const UPDATEMEMBER_SUCCESS = "UPDATEMEMBER_SUCCESS";
export const UPDATEMEMBER_FAIL = "UPDATEMEMBER_FAIL";
export const UPDATEDEFAULTFLAG_SUCCESS = "UPDATEDEFAULTFLAG_SUCCESS";
export const UPDATEDEFAULTFLAG_FAIL = "UPDATEMEMBER_FAIL";
export const GETWORKSPACELIST_SUCCESS = "GETWORKSPACELIST_SUCCESS";
export const GETWORKSPACELIST_FAIL = "GETWORKSPACELIST_FAIL";
export const GETWORKSPACELISTROLE_SUCCESS = "GETWORKSPACELISTROLE_SUCCESS";
export const GETWORKSPACELISTROLE_FAIL = "GETWORKSPACELISTROLE_FAIL";
export const LOGOUT = "LOGOUT";
export const ADDMEMBERGROUP_SUCCESS = "ADDMEMBERGROUP_SUCCESS";
export const ADDMEMBERGROUP_FAIL = "ADDMEMBERGROUP_FAIL";
export const GETGROUPMEMBER_SUCCESS = "GETGROUPMEMBER_SUCCESS";
export const GETGROUPMEMBER_FAIL = "GETGROUPMEMBER_FAIL";
export const TASKTRACK_SUCCESS = "TASKTRACK_SUCCESS";
export const TASKTRACK_FAIL = "TASKTRACK_FAIL";
export const UPDATENOTES_SUCCESS = "UPDATENOTES_SUCCESS";
export const UPDATENOTES_FAIL = "UPDATENOTES_FAIL";
export const GETNOTES_SUCCESS = "GETNOTES_SUCCESS";
export const GETNOTES_FAIL = "GETNOTES_FAIL";
export const UPDATEPROJECTTASK_SUCCESS = "UPDATEPROJECTTASK_SUCCESS ";
export const UPDATEPROJECTTASK_FAIL = "UPDATEPROJECTTASK_FAIL";
export const UPDATETEAM_SUCCESS = "UPDATETEAM_SUCCESS";
export const UPDATETEAM_FAIL = "UPDATETEAM_FAIL";
export const UPDATEVISIBILITY_SUCCESS = "UPDATEVISIBILITY_SUCCESS";
export const UPDATEVISIBILITY_FAIL = "UPDATEVISIBILITY_FAIL";
export const GETTASKASSIGNEELIST_SUCCESS = "GETTASKASSIGNEELIST_SUCCESS";
export const GETTASKASSIGNEELIST_FAIL = "GETTASKASSIGNEELIST_FAIL";
export const DELETETEAM_SUCCESS = "DELETETEAM_SUCCESS";
export const DELETETEAM_FAIL = "DELETETEAM_FAIL";
export const GETGROUPS_SUCCESS = "GETGROUPS_SUCCESS";
export const GETGROUPS_FAIL = "GETGROUPS_FAIL";
export const UPDATEGROUP_SUCCESS = "UPDATETEAM_SUCCESS";
export const UPDATEGROUP_FAIL = "UPDATETEAM_FAIL";
export const PROJECTESTIMATETYPE_SUCCESS = "PROJECTESTIMATETYPE_SUCCESS";
export const PROJECTESTIMATETYPE_FAIL = "PROJECTESTIMATETYPE_FAIL";
export const UPDATEROLE_SUCCESS = "UPDATEROLE_SUCCESS";
export const UPDATEROLE_FAIL = "UPDATEROLE_FAIL";
export const ADD_TO_FAVOURITE_SUCCESS = "ADD_TO_FAVOURITE_SUCCESS";
export const ADD_TO_FAVOURITE_FAIL = "ADD_TO_FAVOURITE_FAIL";
export const DELETE_OKR_FAVOURITE_SUCCESS = "DELETE_OKR_FAVOURITE_SUCCESS";
export const DELETE_OKR_FAVOURITE_FAIL = "DELETE_OKR_FAVOURITE_FAIL";
export const UPDATESETTINGS_SUCCESS = "UPDATESETTINGS_SUCCESS";
export const UPDATESETTINGS_FAIL = "UPDATESETTINGS_FAIL";
export const GET_TIMESHEET_PROJECT_LIST_SUCCESS =
  "GET_TIMESHEET_PROJECT_LIST_SUCCESS";
export const GET_TIMESHEET_PROJECT_LIST_FAIL =
  "GET_TIMESHEET_PROJECT_LIST_FAIL";
export const ADD_MEMBER_TIMESHEET_SUCCESS = "ADD_MEMBER_TIMESHEET_SUCCESS";
export const ADD_MEMBER_TIMESHEET_FAIL = "ADD_MEMBER_TIMESHEET_FAIL";
export const GETMEMBERTIMESHEET_SUCCESS = "GETMEMBERTIMESHEET_SUCCESS";
export const GETMEMBERTIMESHEET_FAIL = "GETMEMBERTIMESHEET_FAIL";
export const GETMYAPPROVALTIMESHEETMODAL_SUCCESS =
  "GETMYAPPROVALTIMESHEETMODAL_SUCCESS";
export const GETMYAPPROVALTIMESHEETMODAL_FAIL =
  "GETMYAPPROVALTIMESHEETMODAL_FAIL";
export const DELETEMEMBERTIMESHEET_SUCCESS = "DELETEMEMBERTIMESHEET_SUCCESS";
export const DELETEMEMBERTIMESHEET_FAIL = "DELETEMEMBERTIMESHEET_FAIL";
export const UPDATETIMESHEETHOURS_SUCCESS = "UPDATETIMESHEETHOURS_SUCCESS";
export const UPDATETIMESHEETHOURS_FAIL = "UPDATETIMESHEETHOURS_FAIL";
export const GETDEPARTMENTLIST_SUCCESS = "GETDEPARTMENTLIST_SUCCESS";
export const GETDEPARTMENTLIST_FAIL = "GETDEPARTMENTLIST_FAIL";
export const GETALLCUSTOMERLIST_SUCCESS = "GETALLCUSTOMERLIST_SUCCESS";
export const GETALLCUSTOMERLIST_FAIL = "GETALLCUSTOMERLIST_FAIL";
export const GET_AREA_GRAPH_SUCCESS = "GET_AREA_GRAPH_SUCCESS";
export const GET_AREA_GRAPH_FAIL = "GET_AREA_GRAPH_FAIL";
export const GET_STATISTICS_SUCCESS = "GET_STATISTICS_SUCCESS";
export const GET_STATISTICS_FAIL = "GET_STATISTICS_FAIL";
export const UPDATETIMESHEETPROJECT_SUCCESS = "UPDATETIMESHEETPROJECT_SUCCESS";
export const UPDATETIMESHEETPROJECT_FAIL = "UPDATETIMESHEETPROJECT_FAIL";
export const REPORTSUMMARY_SUCCESS = "REPORTSUMMARY_SUCCESS";
export const REPORTSUMMARY_FAIL = "REPORTSUMMARY_FAIL";
export const REPORTSUMMARYCSV_SUCCESS = "REPORTSUMMARYCSV_SUCCESS";
export const REPORTSUMMARYCSV_FAIL = "REPORTSUMMARYCSV_FAIL";
export const CREATESESSION_SUCCESS = "CREATESESSION_SUCCESS";
export const CREATESESSION_FAIL = "CREATESESSION_FAIL";
export const SEARCHSESSION_SUCCESS = "SEARCHSESSION_SUCCESS";
export const SEARCHSESSION_FAIL = "SEARCHSESSION_FAIL";
export const DELETESESSION_SUCCESS = "DELETESESSION_SUCCESS";
export const DELETESESSION_FAIL = "DELETESESSION_FAIL";
export const UPDATESESSION_SUCCESS = "UPDATESESSION_SUCCESS";
export const UPDATESESSION_FAIL = "UPDATESESSION_FAIL";
export const SESSIONSTATUS_SUCCESS = "SESSIONSTATUS_SUCCESS";
export const SESSIONSTATUS_FAIL = "SESSIONSTATUS_FAIL";
export const GETSESSION_SUCCESS = "GETSESSION_SUCCESS";
export const GETSESSION_FAIL = "GETSESSION_FAIL";
export const GETSESSION_SUCCESS_ALL = "GETSESSION_SUCCESS_ALL";
export const GETSESSION_FAIL_ALL = "GETSESSION_FAIL_ALL";
export const GETFINDOBJECTIVE_SUCCESS = "GETFINDOBJECTIVE_SUCCESS";
export const GETFINDOBJECTIVE_FAIL = "GETFINDOBJECTIVE_FAIL";
export const GETWORKSPACEMEMBEROKR_SUCCESS = "GETWORKSPACEMEMBEROKR_SUCCESS";
export const GETWORKSPACEMEMBEROKR_FAIL = "GETWORKSPACEMEMBEROKR_FAIL";
export const CREATEOBJECTIVE_SUCCESS = "CREATEOBJECTIVE_SUCCESS";
export const CREATEOBJECTIVE_FAIL = "CREATEOBJECTIVE_FAIL";
export const BULK_UPLOAD_SUCCESS = "BULK_UPLOAD_SUCCESS";
export const BULK_UPLOAD_FAIL = "BULK_UPLOAD_FAIL";
export const CLONE_OBJECTIVE_SUCCESS = "CLONE_OBJECTIVE_SUCCESS";
export const CLONE_OBJECTIVE_FAIL = "CLONE_OBJECTIVE_FAIL";
export const OBJECTIVE_ALIMENTFILTER_SUCCESS = "CLONE_OBJECTIVE_SUCCESS";
export const OBJECTIVE_ALIMENTFILTER_FAIL = "CLONE_OBJECTIVE_FAIL";
export const OBJECTIVEMULTISEARCH_SUCCESS = "OBJECTIVEMULTISEARCH_SUCCESS";
export const OBJECTIVEMULTISEARCH_FAIL = "OBJECTIVEMULTISEARCH_FAIL";
export const GETOBJECTIVE_SUCCESS = "GETOBJECTIVE_SUCCESS";
export const GETOBJECTIVE_FAIL = "GETOBJECTIVE_FAIL";
export const VALIDATEINVITES_SUCCESS = "VALIDATEINVITES_SUCCESS";
export const VALIDATEINVITES_FAIL = "VALIDATEINVITES_FAIL";
export const UPDATECUSTOMERSTATUS_SUCCESS = "UPDATECUSTOMERSTATUS_SUCCESS";
export const UPDATECUSTOMERSTATUS_FAIL = "UPDATECUSTOMERSTATUS_FAIL";
export const GETOBJECTIVE_USERLOGS_SUCCESS = "GETOBJECTIVE_USERLOGS_SUCCESS";
export const GETOBJECTIVE_USERLOGS_FAIL = "GETOBJECTIVE_USERLOGS_FAIL";
export const UPDATEBILLABLE_SUCCESS = "UPDATEBILLABLE_SUCCESS";
export const UPDATEBILLABLE_FAIL = "UPDATEBILLABLE_FAIL";
export const UPDATEWORKHOURS_SUCCESS = "UPDATEWORKHOURS_SUCCESS";
export const UPDATEWORKHOURS_FAIL = "UPDATEWORKHOURS_FAIL";
export const EDITPROFILE_SUCCESS = "EDITPROFILE_SUCCESS";
export const EDITPROFILE_FAIL = "EDITPROFILE_FAIL";
export const ADDREMINDER_SUCCESS = "ADDREMINDER_SUCCESS";
export const ADDREMINDER_FAIL = "ADDREMINDER_FAIL";
export const GETREMINDERLIST_SUCCESS = "GETREMINDERLIST_SUCCESS";
export const GETREMINDERLIST_FAIL = "GETREMINDERLIST_FAIL";
export const DELETEREMINDER_SUCCESS = "DELETEREMINDER_SUCCESS";
export const DELETEREMINDER_FAIL = "DELETEREMINDER_FAIL";
export const GETREPORTUSER_SUCCESS = "GETREPORTUSER_SUCCESS";
export const GETREPORTUSER_FAIL = "GETREPORTUSER_FAIL";
export const REPORTSUMMARYUSERS_SUCCESS = "REPORTSUMMARYUSERS_SUCCESS";
export const REPORTSUMMARYUSERS_FAIL = "REPORTSUMMARYUSERS_FAIL";
export const REPORTSUMMARYWEEKLYTIMESHEETREPORT_SUCCESS =
  "REPORTSUMMARYWEEKLYTIMESHEETREPORT_SUCCESS";
export const REPORTSUMMARYWEEKLYTIMESHEETREPORT_FAIL =
  "REPORTSUMMARYWEEKLYTIMESHEETREPORT_FAIL";
export const REPORTSUMMARYPROJECTS_SUCCESS = "REPORTSUMMARYPROJECTS_SUCCESS";
export const REPORTSUMMARYPROJECTS_FAIL = "REPORTSUMMARYPROJECTS_FAIL";
export const REPORTSUMMARYTASKS_SUCCESS = "REPORTSUMMARYTASKS_SUCCESS";
export const REPORTSUMMARYTASKS_FAIL = "REPORTSUMMARYTASKS_FAIL";
export const REPORTSUMMARYDEPARTMENT_SUCCESS =
  "REPORTSUMMARYDEPARTMENT_SUCCESS";
export const REPORTSUMMARYDEPARTMENT_FAIL = "REPORTSUMMARYDEPARTMENT_FAIL";
export const ADDMEMBERTIMETRACKER_SUCCESS = "ADDMEMBERTIMETRACKER_SUCCESS";
export const ADDMEMBERTIMETRACKER_FAIL = "ADDMEMBERTIMETRACKER_FAIL";
export const EDITMEMBERTIMETRACKER_SUCCESS = "EDITMEMBERTIMETRACKER_SUCCESS";
export const EDITMEMBERTIMETRACKER_FAIL = "EDITMEMBERTIMETRACKER_FAIL";
export const TIME_SHEET_TIMER = "TIME_SHEET_TIMER";
export const TIMER_START = "TIMER_START";
export const PLAY_START = "PLAY_START";
export const GET_TIMER = "GET_TIMER";
export const REPORTSUMMARYGRAPHS_SUCCESS = "REPORTSUMMARYGRAPHS_SUCCESS";
export const REPORTSUMMARYGRAPHS_FAIL = "REPORTSUMMARYGRAPHS_FAIL";
export const CHANGEMEMBERMANAGER_SUCCESS = "CHANGEMEMBERMANAGER_SUCCESS";
export const CHANGEMEMBERMANAGER_FAIL = "CHANGEMEMBERMANAGER_FAIL";
export const MANAGERDROUPDOWN_SUCCESS = "MANAGERDROUPDOWN_SUCCESS";
export const MANAGERDROUPDOWN_FAIL = "MANAGERDROUPDOWN_FAIL";
export const ASSIGNOTHERMANAGER_SUCCESS = "ASSIGNOTHERMANAGER_SUCCESS";
export const ASSIGNOTHERMANAGER_FAIL = "ASSIGNOTHERMANAGER_FAIL";
export const UPDATEAPPROVESTATUS_SUCCESS = "UPDATEAPPROVESTATUS_SUCCESS";
export const UPDATEAPPROVESTATUS_FAIL = "UPDATEAPPROVESTATUS_FAIL";
export const UPDATEEXPENSEAPPROVESTATUS_SUCCESS =
  "UPDATEEXPENSEAPPROVESTATUS_SUCCESS";
export const UPDATEEXPENSEAPPROVESTATUS_FAIL =
  "UPDATEEXPENSEAPPROVESTATUS_FAIL";
export const ADD_DYNAMICFIELD_SUCCESS = "ADD_DYNAMICFIELD_SUCCESS";
export const ADD_DYNAMICFIELD_FAIL = "ADD_DYNAMICFIELD_FAIL";
export const UPDATEFIELDSTATUS_SUCCESS = "UPDATEFIELDSTATUS_SUCCESS";
export const UPDATEFIELDSTATUS_FAIL = "UPDATEFIELDSTATUS_FAIL";
export const GETDYNAMICFIELDS_SUCCESS = "GETDYNAMICFIELDS_SUCCESS";
export const GETDYNAMICFIELDS_FAIL = "GETDYNAMICFIELDS_FAIL";
export const SAVEDYNAMICFIELDS_SUCCESS = "SAVEDYNAMICFIELDS_SUCCESS";
export const SAVEDYNAMICFIELDS_FAIL = "SAVEDYNAMICFIELDS_FAIL";
export const GETCUSTOMFIELD_SUCCESS = "GETCUSTOMFIELD_SUCCESS";
export const GETCUSTOMFIELD_FAIL = "GETCUSTOMFIELD_FAIL";
export const UPDATEDYNAMICFIELD_SUCCESS = "UPDATEDYNAMICFIELD_SUCCESS";
export const UPDATEDYNAMICFIELD_FAIL = "UPDATEDYNAMICFIELD_FAIL";
export const SEARCHCUSTOMFIELD_SUCCESS = "SEARCHCUSTOMFIELD_SUCCESS";
export const SEARCHCUSTOMFIELD_FAIL = "SEARCHCUSTOMFIELD_FAIL";
export const GETTASKTEMPLATE_SUCCESS = "GETTASKTEMPLATE_SUCCESS";
export const GETTASKTEMPLATE_FAIL = "GETTASKTEMPLATE_FAIL";
export const UPDATETEMPLATESTATUS_SUCCESS = "UPDATETEMPLATESTATUS_SUCCESS";
export const UPDATETEMPLATESTATUS_FAIL = "UPDATETEMPLATESTATUS_FAIL";
export const CREATETASKTEMPLATE_SUCCESS = "CREATETASKTEMPLATE_SUCCESS";
export const CREATETASKTEMPLATE_FAIL = "CREATETASKTEMPLATE_FAIL";
export const GETPROJECTTEMPLATE_SUCCESS = "GETPROJECTTEMPLATE_SUCCESS";
export const GETPROJECTTEMPLATE_FAIL = "GETPROJECTTEMPLATE_FAIL";
export const IMPORTTASKTEMPLATE_SUCCESS = "IMPORTTASKTEMPLATE_SUCCESS";
export const IMPORTTASKTEMPLATE_FAIL = "IMPORTTASKTEMPLATE_FAIL";
export const GETMEMBERLIST_SUCCESS = "GETMEMBERLIST_SUCCESS";
export const GETMEMBERLIST_FAIL = "GETMEMBERLIST_FAIL";
export const GETCUSTOMERS_SUCCESS = "GETCUSTOMERS_SUCCESS";
export const GETCUSTOMERS_FAIL = "GETCUSTOMERS_FAIL";
export const GETPROJECTS_SUCCESS = "GETPROJECTS_SUCCESS";
export const GETPROJECTS_FAIL = "GETPROJECTS_FAIL";
export const COPYLASTWEEKTS_SUCCESS = "COPYLASTWEEKTS_SUCCESS";
export const COPYLASTWEEKTS_FAIL = "COPYLASTWEEKTS_FAIL";
export const ADDTSTEMPLATE_SUCCESS = "ADDTSTEMPLATE_SUCCESS";
export const ADDTSTEMPLATE_FAIL = "ADDTSTEMPLATE_FAIL";
export const GETTSTEMPLATE_SUCCESS = "GETTSTEMPLATE_SUCCESS";
export const GETTSTEMPLATE_FAIL = "GETTSTEMPLATE_FAIL";
export const UPDATETSTEMPLATE_SUCCESS = "UPDATETSTEMPLATE_SUCCESS";
export const UPDATETSTEMPLATE_FAIL = "UPDATETSTEMPLATE_FAIL";
export const ACTIVATETEMPLATE_SUCCESS = "ACTIVATETEMPLATE_SUCCESS";
export const ACTIVATETEMPLATE_FAIL = "ACTIVATETEMPLATE_FAIL";
export const GETCURRENCY_SUCCESS = "GETCURRENCY_SUCCESS";
export const GETCURRENCY_FAIL = "GETCURRENCY_FAIL";
export const GETINVOICEDETAILS_SUCCESS = "GETINVOICEDETAILS_SUCCESS";
export const GETINVOICEDETAILS_FAIL = "GETINVOICEDETAILS_FAIL";
export const ROW_COUNT = "ROW_COUNT";
export const GET_INVOICE_STATISTICS_GRAPH_SUCCESS =
  "GET_INVOICE_STATISTICS_GRAPH_SUCCESS";
export const GET_INVOICE_STATISTICS_GRAPH_FAIL =
  "GET_INVOICE_STATISTICS_GRAPH_FAIL";
export const GET_INVOICE_CURRENCIES_SUCCESS = "GET_INVOICE_CURRENCIES_SUCCESS";
export const GET_INVOICE_CURRENCIES_FAIL = "GET_INVOICE_CURRENCIES_FAIL";
export const GET_INVOICE_DETAILS_POPUP_SUCCESS =
  "GET_INVOICE_DETAILS_POPUP_SUCCESS";
export const GET_INVOICE_DETAILS_POPUP_FAIL = "GET_INVOICE_DETAILS_POPUP_FAIL";
export const GET_TOTAL_INVOICE_DATA_SUCCESS = "GET_TOTAL_INVOICE_DATA_SUCCESS";
export const GET_TOTAL_INVOICE_DATA_FAIL = "GET_TOTAL_INVOICE_DATA_FAIL";
export const CREATEINVOICE_SUCCESS = "CREATEINVOICE_SUCCESS";
export const CREATEINVOICE_FAIL = "CREATEINVOICE_FAIL";
export const GETINVOICESETTING_SUCCESS = "GETINVOICESETTING_SUCCESS";
export const GETINVOICESETTING_FAIL = "GETINVOICESETTING_FAIL";
export const SAVEINVOICESETTING_SUCCESS = "SAVEINVOICESETTING_SUCCESS";
export const SAVEINVOICESETTING_FAIL = "SAVEINVOICESETTING_FAIL";
export const GETEMAILLOG_SUCCESS = "GETEMAILLOG_SUCCESS";
export const GETEMAILLOG_FAIL = "GETEMAILLOG_FAIL";
export const GETAUDITLOG_SUCCESS = "GETAUDITLOG_SUCCESS";
export const GETAUDITLOG_FAIL = "GETAUDITLOG_FAIL";
export const SENDINSTANTREMINDER_SUCCESS = "SENDINSTANTREMINDER_SUCCESS";
export const SENDINSTANTREMINDER_FAIL = "SENDINSTANTREMINDER_FAIL";
export const GETSINGLEINVOICEDETAILES_SUCCESS =
  "GETSINGLEINVOICEDETAILES_SUCCESS";
export const GETSINGLEINVOICEDETAILES_FAIL = "GETSINGLEINVOICEDETAILES_FAIL";
export const DELETEINVOICE_SUCCESS = "DELETEINVOICE_SUCCESS";
export const DELETEINVOICE_FAIL = "DELETEINVOICE_FAIL";
export const DUPLICATEINVOICE_SUCCESS = "DUPLICATEINVOICE_SUCCESS";
export const DUPLICATEINVOICE_FAIL = "DUPLICATEINVOICE_FAIL";
export const MARKUSPAID_SUCCESS = "MARKUSPAID_SUCCESS";
export const MARKUSPAID_FAIL = "MARKUSPAID_FAIL";
export const DOWNLOADINVOICE_SUCCESS = "DOWNLOADINVOICE_SUCCESS";
export const DOWNLOADINVOICE_FAIL = "DOWNLOADINVOICE_FAIL";
export const RECURRINGDETAILES_SUCCESS = "RECURRINGDETAILES_SUCCESS";
export const RECURRINGDETAILES_FAIL = "RECURRINGDETAILES_FAIL";
export const STOPRECURRING_SUCCESS = "STOPRECURRING_SUCCESS";
export const STOPRECURRING_FAIL = "STOPRECURRING_FAIL";
export const EDITINVOICE_SUCCESS = "EDITINVOICE_SUCCESS";
export const EDITINVOICE_FAIL = "EDITINVOICE_FAIL";
export const UPLOADATTACHMENT_SUCCESS = "UPLOADATTACHMENT_SUCCESS";
export const UPLOADATTACHMENT_FAIL = "UPLOADATTACHMENT_FAIL";
export const SCHEDULELATER_SUCCESS = "SCHEDULELATER_SUCCESS";
export const SCHEDULELATER_FAIL = "SCHEDULELATER_FAIL";
export const SET_STOPWATCH_TIME = "SET_STOPWATCH_TIME";
export const UPDATELOGO_SUCCESS = "UPDATELOGO_SUCCESS";
export const UPDATELOGO_FAIL = "UPDATELOGO_FAIL";
export const ADDEMAILLOG_SUCCESS = "ADDEMAILLOG_SUCCESS";
export const ADDEMAILLOG_FAIL = "ADDEMAILLOG_FAIL";
export const LOCKANDUNLOCK_SUCCESS = "LOCKANDUNLOCK_SUCCESS";
export const LOCKANDUNLOCK_FAIL = "LOCKANDUNLOCK_FAIL";
export const DELETEADDATTACHMENT_SUCCESS = "DELETEADDATTACHMENT_SUCCESS";
export const DELETEADDATTACHMENT_FAIL = "DELETEADDATTACHMENT_FAIL";
export const GETSETTINGINVOICEDETAILS_SUCCESS =
  "GETSETTINGINVOICEDETAILS_SUCCESS";
export const GETSETTINGINVOICEDETAILS_FAIL = "DELETEADDATTACHMENT_FAIL";
export const REPORTSUMMARYNEW_SUCCESS = "REPORTSUMMARYNEW_SUCCESS";
export const REPORTSUMMARYNEW_FAIL = "REPORTSUMMARYNEW_FAIL";
export const OKRREPORTSUMMARYNEW_SUCCESS = "OKRREPORTSUMMARYNEW_SUCCESS";
export const OKRREPORTSUMMARYNEW_FAIL = "OKRREPORTSUMMARYNEW_FAIL";
export const GETREPORTLIST_SUCCESS = "GETREPORTLIST_SUCCESS";
export const GETREPORTLIST_FAIL = "GETREPORTLIST_FAIL";
export const GENERATEATTACHEMENT_SUCCESS = "GENERATEATTACHEMENT_SUCCESS";
export const GENERATEATTACHEMENT_FAIL = "GENERATEATTACHEMENT_FAIL";
export const GETALLHOLIDAY_SUCCESS = "GETALLHOLIDAY_SUCCESS";
export const GETALLHOLIDAY_FAIL = "GETALLHOLIDAY_FAIL";
export const TIMEOFFBALANCEEXPORT_SUCCESS = "TIMEOFFBALANCEEXPORT_SUCCESS";
export const TIMEOFFBALANCEEXPORT_FAIL = "TIMEOFFBALANCEEXPORT_FAIL";
export const CREATEORUPDATEHOLIDAY_SUCCESS = "CREATEORUPDATEHOLIDAY_SUCCESS";
export const CREATEORUPDATEHOLIDAY_FAIL = "CREATEORUPDATEHOLIDAY_FAIL";
export const EDITHOLIDAY_SUCCESS = "EDITHOLIDAY_SUCCESS";
export const EDITHOLIDAY_FAIL = "EDITHOLIDAY_FAIL";
export const GETBYID_SUCCESS = "GETBYID_SUCCESS";
export const GETBYID_FAIL = "GETBYID_FAIL";
export const GETALLPOLICY_SUCCESS = "GETALLPOLICY_SUCCESS";
export const GETALLPOLICY_FAIL = "GETALLPOLICY_FAIL";
export const CREATEPOLICY_SUCCESS = "CREATEPOLICY_SUCCESS";
export const CREATEPOLICY_FAIL = "CREATEPOLICY_FAIL";
export const GETBALANCE_SUCCESS = "GETBALANCE_SUCCESS";
export const GETBALANCE_FAIL = "GETBALANCE_FAIL";
export const DELETEPOLICY_SUCCESS = "DELETEPOLICY_SUCCESS";
export const DELETEPOLICY_FAIL = "DELETEPOLICY_FAIL";
export const GETSINGLEPOLICYDETAILES_SUCCESS =
  "GETSINGLEPOLICYDETAILES_SUCCESS";
export const GETSINGLEPOLICYDETAILES_FAIL = "GETSINGLEPOLICYDETAILES_FAIL";
export const EDITPOLICY_SUCCESS = "EDITPOLICY_SUCCESS";
export const EDITPOLICY_FAIL = "EDITPOLICY_FAIL";
export const GETHISTORY_SUCCESS = "GETHISTORY_SUCCESS";
export const GETHISTORY_FAIL = "GETHISTORY_FAIL";
export const BALANCE_SUCCESS = " BALANCE_SUCCESS";
export const BALANCE_FAIL = " BALANCE_FAIL";
export const GETREQUESTLIST_SUCCESS = "GETREQUESTLIST_SUCCESS";
export const GETREQUESTLIST_FAIL = "GETREQUESTLIST_FAIL";
export const GETASSIGNEESLIST_SUCCESS = "GETASSIGNEESLIST_SUCCESS";
export const GETASSIGNEESLIST_FAIL = "GETASSIGNEESLIST_FAIL";
export const GETAPPROVERSLIST_SUCCESS = "GETAPPROVERSLIST_SUCCESS";
export const GETAPPROVERSLIST_FAIL = "GETAPPROVERSLIST_FAIL";
export const CHANGESTATUS_SUCCESS = "CHANGESTATUS_SUCCESS";
export const CHANGESTATUS_FAIL = "CHANGESTATUS_FAIL";
export const CREATEREQUESTTIMEOFF_SUCCESS = "CREATEREQUESTTIMEOFF_SUCCESS";
export const CREATEREQUESTTIMEOFF_FAIL = "CREATEREQUESTTIMEOFF_FAIL";
export const GETPOLICIESLIST_SUCCESS = "GETPOLICIESLIST_SUCCESS";
export const GETPOLICIESLIST_FAIL = "GETPOLICIESLIST_FAIL";
export const GETTIMELINE_SUCCESS = "GETTIMELINE_SUCCESS";
export const GETTIMELINE_FAIL = "GETTIMELINE_FAIL";
export const GETTIMELINE_EXPORT_SUCCESS = "GETTIMELINE_EXPORT_SUCCESS";
export const GETTIMELINE_EXPORT_FAIL = "GETTIMELINE_EXPORT_FAIL";
export const REINVITEMEMBER_SUCCESS = "REINVITEMEMBER_SUCCESS";
export const REINVITEMEMBER_FAIL = "REINVITEMEMBER_FAIL";
export const RESENDVERIFICATION_SUCCESS = "RESENDVERIFICATION_SUCCESS";
export const RESENDVERIFICATION_FAIL = "RESENDVERIFICATION_FAIL";
export const GETPROJECTLIST_SUCCESS = "GETPROJECTLIST_SUCCESS";
export const GETPROJECTLIST_FAIL = "GETPROJECTLIST_FAIL";
export const EDITREMINDER_SUCCESS = "EDITREMINDER_SUCCESS";
export const EDITREMINDER_FAIL = "EDITREMINDER_FAIL";
export const CREATECATEGORY_SUCCESS = "CREATECATEGORY_SUCCESS";
export const CREATECATEGORY_FAIL = "CREATECATEGORY_FAIL";
export const FETCHCATEGORY_SUCCESS = "FETCHCATEGORY_SUCCESS";
export const FETCHCATEGORY_FAIL = "FETCHCATEGORY_FAIL";
export const EDITCATEGORY_SUCCESS = "EDITCATEGORY_SUCCESS";
export const EDITCATEGORY_FAIL = "EDITCATEGORY_FAIL";
export const UPDATECATEGORYSTATUS_SUCCESS = "UPDATECATEGORYSTATUS_SUCCESS";
export const UPDATECATEGORYSTATUS_FAIL = "UPDATECATEGORYSTATUS_FAIL";
export const TIMESHEETDETAILS_SUCCESS = "TIMESHEETDETAILS_SUCCESS";
export const TIMESHEETDETAILS_FAIL = "TIMESHEETDETAILS_FAIL";
export const GETMEMBER_SUCCESS = "GETMEMBER_SUCCESS";
export const GETMEMBER_FAIL = "GETMEMBER_FAIL";
export const GETAPPROVERS_SUCCESS = "GETAPPROVERS_SUCCESS";
export const GETAPPROVERS_FAIL = "GETAPPROVERS_FAIL";
export const ASSIGNAPPROVERS_SUCCESS = "ASSIGNAPPROVERS_SUCCESS";
export const ASSIGNAPPROVERS_FAIL = "ASSIGNAPPROVERS_FAIL";
export const GETCATEGORY_SUCCESS = "GETCATEGORY_SUCCESS";
export const GETCATEGORY_FAIL = "GETCATEGORY_FAIL";
export const CREATEEXPENSE_SUCCESS = "CREATEEXPENSE_SUCCESS";
export const CREATEEXPENSE_FAIL = "CREATEEXPENSE_FAIL";
export const GET_COMMENT_HISTORY_SUCCESS = "GET_COMMENT_HISTORY_SUCCESS";
export const GET_COMMENT_HISTORY_FAIL = "GET_COMMENT_HISTORY_FAIL";
export const FETCHEXPENSE_SUCCESS = "FETCHEXPENSE_SUCCESS";
export const FETCHEXPENSE_FAIL = "FETCHEXPENSE_FAIL";
export const FETCHEXPENSECURRENCY_SUCCESS = "FETCHEXPENSECURRENCY_SUCCESS";
export const FETCHEXPENSECURRENCY_FAIL = "FETCHEXPENSECURRENCY_FAIL";
export const FETCHMARKASREIMBURSE_SUCCESS = "FETCHMARKASREIMBURSE_SUCCESS";
export const FETCHMARKASREIMBURSE_FAIL = "FETCHMARKASREIMBURSE_FAIL";
export const EDITEXPENSE_SUCCESS = "EDITEXPENSE_SUCCESS";
export const EDITEXPENSE_FAIL = "EDITEXPENSE_FAIL";
export const DELETEEXPENSE_SUCCESS = "DELETEEXPENSE_SUCCESS";
export const DELETEEXPENSE_FAIL = "DELETEEXPENSE_FAIL";
export const ARCHIEVEEXPENSE_SUCCESS = "ARCHIEVEEXPENSE_SUCCESS";
export const ARCHIEVEEXPENSE_FAIL = "ARCHIEVEEXPENSE_FAIL";
export const SUBMITAPPROVEEXPENSE_SUCCESS = "SUBMITAPPROVEEXPENSE_SUCCESS";
export const SUBMITAPPROVEEXPENSE_FAIL = "SUBMITAPPROVEEXPENSE_FAIL";
export const CHANGEEXPENSE_SUCCESS = "CHANGEEXPENSE_SUCCESS";
export const CHANGEEXPENSE_FAIL = "CHANGEEXPENSE_FAIL";
export const REMINDAPPROVEEXPENSE_SUCCESS = "REMINDAPPROVEEXPENSE_SUCCESS";
export const REMINDAPPROVEEXPENSE_FAIL = "REMINDAPPROVEEXPENSE_FAIL";
export const GET_EXPENSE_DASHBOARD_DATA_SUCCESS =
  "GET_EXPENSE_DASHBOARD_DATA_SUCCESS";
export const GET_EXPENSE_DASHBOARD_DATA_FAIL =
  "GET_EXPENSE_DASHBOARD_DATA_FAIL";
export const APPROVALLISTV2_SUCCESS = "RETRIEVEEXPENSE_SUCCESS";
export const APPROVALLISTV2_FAIL = "APPROVALLISTV2_FAIL";
export const GETMEMBERTIMESHEETDETAILS_SUCCESS =
  "GETMEMBERTIMESHEETDETAILS_SUCCESS";
export const GETMEMBERTIMESHEETDETAILS_FAIL = "GETMEMBERTIMESHEETDETAILS_FAIL";
export const TIMEOFF_REQUESTLIST_SUCCESS = "RETRIEVETIMEOFF_SUCCESS";
export const TIMEOFF_REQUESTLIST_FAIL = "TIMEOFF_REQUESTLIST_FAIL";
export const APPROVE_TIMEOFF_SUCCESS = "APPROVE_TIMEOFF_SUCCESS";
export const APPROVE_TIMEOFF_FAIL = "APPROVE_TIMEOFF_FAIL";
export const MemberExpenseApproval_SUCCESS = "MemberExpenseApproval_SUCCESS";
export const MemberExpenseApproval_FAIL = "MemberExpenseApproval_FAIL";
export const APPROVEALL_SUCCESS = "APPROVEALL_SUCCESS";
export const APPROVEALL_FAIL = "APPROVEALL_FAIL";
export const RETRIEVEEXPENSE_SUCCESS = "RETRIEVEEXPENSE_SUCCESS";
export const RETRIEVEEXPENSE_FAIL = "RETRIEVEEXPENSE_FAIL";
export const GETWORKSPACEOWNERS_SUCCESS = "GETWORKSPACEOWNERS_SUCCESS";
export const GETWORKSPACEOWNERS_FAIL = "GETWORKSPACEOWNERS_FAIL";
export const GET_CALENDAR_TIMESHEET_SUCCESS = "GET_CALENDAR_TIMESHEET_SUCCESS";
export const GET_CALENDAR_TIMESHEET_FAIL = "GET_CALENDAR_TIMESHEET_FAIL";
export const GET_CALENDAR_TIMESHEET_DAY_SUCCESS =
  "GET_CALENDAR_TIMESHEET_DAY_SUCCESS";
export const GET_CALENDAR_TIMESHEET_DAY_FAIL =
  "GET_CALENDAR_TIMESHEET_DAY_FAIL";
export const GETOBJECTIVES_SUCCESS = "GETOBJECTIVES_SUCCESS";
export const GETOBJECTIVES_FAIL = "GETOBJECTIVES_FAIL";
export const GET_CHILD_OBJECTIVES_SUCCESS = "GET_CHILD_OBJECTIVES_SUCCESS";
export const GET_CHILD_OBJECTIVES_FAIL = "GET_CHILD_OBJECTIVES_FAIL";
export const GET_OBJECTIVES_ALIGNMENT_SUCCESS =
  "GET_OBJECTIVES_ALIGNMENT_SUCCESS";
export const GET_OBJECTIVES_ALIGNMENT_FAIL = "GET_OBJECTIVES_ALIGNMENT_FAIL";
export const CREATEKEYRESULT_SUCCESS = "CREATEKEYRESULT_SUCCESS";
export const CREATEKEYRESULT_FAIL = "CREATEKEYRESULT_FAIL";
export const CREATEKEYRESULT_BULK_SUCCESS = "CREATEKEYRESULT_BULK_SUCCESS";
export const CREATEKEYRESULT_BULK_FAIL = "CREATEKEYRESULT_BULK_FAIL";
export const GET_KEYRESULT_SUCCESS = "GET_KEYRESULT_SUCCESS";
export const GET_KEYRESULT_FAIL = "GET_KEYRESULT_FAIL";
export const UPDATE_KEYRESULT_POPUP_SUCCESS = "UPDATE_KEYRESULT_POPUP_SUCCESS";
export const UPDATE_KEYRESULT_POPUP_FAIL = "UPDATE_KEYRESULT_POPUP_FAIL";
export const EDITKEYRESULT_SUCCESS = "EDITKEYRESULT_SUCCESS";
export const EDITKEYRESULT_FAIL = "EDITKEYRESULT_FAIL";
export const OBJECTIVESPROJECTLIST_SUCCESS = "OBJECTIVESPROJECTLIST_SUCCESS";
export const OBJECTIVESPROJECTLIST_FAIL = "OBJECTIVESPROJECTLIST_FAIL";
export const OBJECTIVESTASKLIST_SUCCESS = "OBJECTIVESTASKLIST_SUCCESS";
export const OBJECTIVESTASKLIST_FAIL = "OBJECTIVESPROJECTLIST_FAIL";
export const OBJECTIVETASKLINK_SUCCESS = "OBJECTIVETASKLINK_SUCCESS";
export const OBJECTIVETASKLINK_FAIL = "OBJECTIVESPROJECTLIST_FAIL";
export const DELETEKEYRESULT_SUCCESS = "DELETEKEYRESULT_SUCCESS";
export const DELETEKEYRESULT_FAIL = "DELETEKEYRESULT_FAIL";
export const OBJECTIVELINKED_SUCCESS = "OBJECTIVELINKED_SUCCESS";
export const OBJECTIVELINKED_FAIL = "OBJECTIVELINKED_FAIL";
export const SAVE_TEMPLATE_SUCCESS = "SAVE_TEMPLATE_SUCCESS";
export const SAVE_TEMPLATE_FAIL = "SAVE_TEMPLATE_FAIL";
export const GET_TEMPLATES_SUCCESS = "GET_TEMPLATES_SUCCESS";
export const GET_TEMPLATES_FAIL = "GET_TEMPLATES_FAIL";
export const DELETE_TEMPLATES_SUCCESS = "DELETE_TEMPLATES_SUCCESS";
export const DELETE_TEMPLATES_FAIL = "DELETE_TEMPLATES_FAIL";
export const DELETEOBJECTIVETASK_SUCCESS = "DELETEOBJECTIVETASK_SUCCESS";
export const DELETEOBJECTIVETASK_FAIL = "DELETEOBJECTIVETASK_FAIL";
export const OBJECTIVETASKSTATUS_SUCCESS = "OBJECTIVETASKSTATUS_SUCCESS";
export const OBJECTIVETASKSTATUS_FAIL = "OBJECTIVETASKSTATUS_FAIL";
export const EDITOBJECTIVE_SUCCESS = "EDITOBJECTIVE_SUCCESS";
export const EDITOBJECTIVE_FAIL = "EDITOBJECTIVE_FAIL";
export const UPDATEOBJECTIVESTATUS_SUCCESS = "UPDATEOBJECTIVESTATUS_SUCCESS";
export const UPDATEOBJECTIVESTATUS_FAIL = "UPDATEOBJECTIVESTATUS_FAIL";
export const DELETEOBJECTIVE_SUCCESS = "DELETEOBJECTIVE_SUCCESS";
export const DELETEOBJECTIVE_FAIL = "DELETEOBJECTIVE_FAIL";
export const GET_OBJECTIVE_FEEDBACKS_SUCCESS =
  "GET_OBJECTIVE_FEEDBACKS_SUCCESS";
export const GET_OBJECTIVE_FEEDBACKS_FAIL = "GET_OBJECTIVE_FEEDBACKS_FAIL";
export const ADD_OBJECTIVE_FEEDBACKS_SUCCESS =
  "ADD_OBJECTIVE_FEEDBACKS_SUCCESS";
export const ADD_OBJECTIVE_FEEDBACKS_FAIL = "ADD_OBJECTIVE_FEEDBACKS_FAIL";
export const UPDATE_OBJECTIVE_FEEDBACKS_SUCCESS =
  "UPDATE_OBJECTIVE_FEEDBACKS_SUCCESS";
export const UPDATE_OBJECTIVE_FEEDBACKS_FAIL =
  "UPDATE_OBJECTIVE_FEEDBACKS_FAIL";
export const DELETE_OBJECTIVE_FEEDBACKS_SUCCESS =
  "DELETE_OBJECTIVE_FEEDBACKS_SUCCESS";
export const DELETE_OBJECTIVE_FEEDBACKS_FAIL =
  "DELETE_OBJECTIVE_FEEDBACKS_FAIL";
export const GETSESSIONDASHBOARD_SUCCESS = "GETSESSIONDASHBOARD_SUCCESS";
export const GETSESSIONDASHBOARD_FAIL = "GETSESSIONDASHBOARD_FAIL";
export const GETOKRALIGNMENT_SUCCESS = "GETOKRALIGNMENT_SUCCESS";
export const GETOKRALIGNMENT_FAIL = "GETOKRALIGNMENT_FAIL";
export const DELSETELINKEDOBJECTIVE_SUCCESS = "DELSETELINKEDOBJECTIVE_SUCCESS";
export const DELSETELINKEDOBJECTIVE_FAIL = "DELSETELINKEDOBJECTIVE_FAIL";
export const LINKACCESSABILITY_SUCCESS = "LINKACCESSABILITY_SUCCESS";
export const LINKACCESSABILITY_FAIL = "LINKACCESSABILITY_FAIL";
export const UPDATEIMAGE_SUCCESS = "UPDATEIMAGE_SUCCESS";
export const UPDATEIMAGE_FAIL = "UPDATEIMAGE_FAIL";
export const GETMYNUDGES_SUCCESS = "GETMYNUDGES_SUCCESS";
export const GETMYNUDGES_FAIL = "GETMYNUDGES_FAIL";
export const DELETEMYNUDGES_SUCCESS = "DELETEMYNUDGES_SUCCESS";
export const DELETEMYNUDGES_FAIL = "DELETEMYNUDGES_FAIL";
export const SEARCHMYNUDGES_SUCCESS = "SEARCHMYNUDGES_SUCCESS";
export const SEARCHMYNUDGES_FAIL = "SEARCHMYNUDGES_FAIL";
export const GETMYNUDGESDROPDOWN_SUCCESS = "GETMYNUDGESDROPDOWN_SUCCESS";
export const GETMYNUDGESDROPDOWN_FAIL = "GETMYNUDGESDROPDOWN_FAIL";
export const CREATEMYNUDGES_SUCCESS = "CREATEMYNUDGES_SUCCESS";
export const CREATEMYNUDGES_FAIL = "CREATEMYNUDGES_FAIL";
export const CREATERECOMMENDMYNUDGES_SUCCESS =
  "CREATERECOMMENDMYNUDGES_SUCCESS";
export const CREATERECOMMENDMYNUDGES_FAIL = "CREATERECOMMENDMYNUDGES_FAIL";
export const EDITGETMYNUDGES_SUCCESS = "EDITGETMYNUDGES_SUCCESS";
export const EDITGETMYNUDGES_FAIL = "EDITGETMYNUDGES_FAIL";
export const EDITMYNUDGES_SUCCESS = "EDITMYNUDGES_SUCCESS";
export const EDITMYNUDGES_FAIL = "EDITMYNUDGES_FAIL";
export const CHANGESTATUSMYNUDGES_SUCCESS = "CHANGESTATUSMYNUDGES_SUCCESS";
export const CHANGESTATUSMYNUDGES_FAIL = "CHANGESTATUSMYNUDGES_FAIL";
export const TIMEZONECREATENUDGES_SUCCESS = "TIMEZONECREATENUDGES_SUCCESS";
export const TIMEZONECREATENUDGES_FAIL = "TIMEZONECREATENUDGES_FAIL";
export const UPDATE_OKR_SESSION_FILTERKEY = "UPDATE_OKR_SESSION_FILTERKEY";
export const UPDATE_SIDEBAR_STATUS = "UPDATE_SIDEBAR_STATUS";
export const UPDATE_OKR_STATUS = "UPDATE_OKR_STATUS";
export const SCHEDULEMEETING_SUCCESS = "SCHEDULEMEETING_SUCCESS";
export const SCHEDULEMEETING_FAIL = "SCHEDULEMEETING_FAIL";
export const GET_SCHEDULEMEETING_SUCCESS = "GET_SCHEDULEEMEETING_SUCCESS";
export const GET_SCHEDULEMEETING_FAIL = "GET_SCHEDULEEMEETING_FAIL";
export const GET_INDIVIDUAL_MEETING_SUCCESS = "GET_INDIVIDUAL_MEETING_SUCCESS";
export const GET_INDIVIDUAL_MEETING_FAIL = "GET_INDIVIDUAL_MEETING_FAIL";
export const UPDATE_SCHEDULEMEETING_SUCCESS = "UPDATE_SCHEDULEMEETING_SUCCESS";
export const UPDATE_SCHEDULEMEETING_FAIL = "UPDATE_SCHEDULEMEETING_FAIL";
export const DELETE_SCHEDULEMEETING_SUCCESS = "DELETE_SCHEDULEMEETING_SUCCESS";
export const DELETE_SCHEDULEMEETING_FAIL = "DELETE_SCHEDULEMEETING_FAIL";
export const CUSTOMER_SUPPORT_REQUEST_SUCCESS =
  "CUSTOMER_SUPPORT_REQUEST_SUCCESS";
export const CUSTOMER_SUPPORT_REQUEST_FAIL = "CUSTOMER_SUPPORT_REQUEST_FAIL";
export const GETOKRAUDITLOG_SUCCESS = "GETOKRAUDITLOG_SUCCESS";
export const GETOKRAUDITLOG_FAIL = "GETOKRAUDITLOG_FAIL";
export const UPDATE_FEEDBACK_ITEM_SUCCESS = "UPDATE_FEEDBACK_ITEM_SUCCESS";
export const UPDATE_FEEDBACK_ITEM_FAIL = "UPDATE_FEEDBACK_ITEM_FAIL";
export const GET_OKR_TAGS_SUCCESS = "GET_OKR_TAGS_SUCCESS";
export const GET_OKR_TAGS_FAIL = "GET_OKR_TAGS__FAIL";
export const CREATE_OKR_TAGS_SUCCESS = "CREATE_OKR_TAGS_SUCCESS";
export const CREATE_OKR_TAGS_FAIL = "CREATE_OKR_TAGS__FAIL";
export const UPDATE_OKR_TAGS_SUCCESS = "UPDATE_OKR_TAGS_SUCCESS";
export const UPDATE_OKR_TAGS_FAIL = "UPDATE_OKR_TAGS__FAIL";
export const SYNC_CALENDER_GOOGLE_SUCCESS = "SYNC_CALENDER_GOOGLE_SUCCESS";
export const SYNC_CALENDER_MICROSOFT_SUCCESS =
  "SYNC_CALENDER_MICROSOFT_SUCCESS";
export const SYNC_CALENDER_GOOGLE_FAIL = "SYNC_CALENDER_GOOGLE_FAIL";
export const SYNC_CALENDER_MICROSOFT_FAIL = "SYNC_CALENDER_MICROSOFT_FAIL";
export const GETSUPERADMINORG_SUCCESS = "GETWORKSPACEDETAILS_SUCCESS";
export const GETSUPERADMINORG_FAIL = "GETWORKSPACEDETAILS_FAIL";
export const GETSUPERADMINORGLOG_SUCCESS = "GETSUPERADMINORGLOG_SUCCESS";
export const GETSUPERADMINORGLOG_FAIL = "GETSUPERADMINORGLOG_FAIL";
export const GETSUPERADMINMODULES_SUCCESS = "GETSUPERADMINMODULES_SUCCESS";
export const GETSUPERADMINMODULES_FAIL = "GETSUPERADMINMODULES_FAIL";
export const CREATE_NEWORGANIZATION_SUCCESS = "CREATE_NEWORGANIZATION_SUCCESS";
export const CREATE_NEWORGANIZATION_FAIL = "CREATE_NEW_ORGANIZATION_FAIL";
export const UPDATE_SUPERADMIN_MODULE_SUCCESS =
  "UPDATE_SUPERADMIN_MODULE_SUCCESS";
export const UPDATE_SUPERADMIN_MODULE_FAIL = "UPDATE_SUPERADMIN_MODULE_FAIL";
export const UPDATE_ORG_STATUS_SUCCESS = "UPDATE_ORG_STATUS_SUCCESS";
export const UPDATE_ORG_STATUS_FAIL = "UPDATE_ORG_STATUS_FAIL";
export const GET_ORGANIZATIONDETAIL_SUCCESS = "GET_ORGANIZATIONDETAIL_SUCCESS";
export const GET_ORGANIZATIONDETAIL_FAIL = "GET_ORGANIZATIONDETAIL_FAIL";
export const SEND_INVITE_SUCCESS = "SEND_INVITE_SUCCESS";
export const SEND_INVITE_FAIL = "SEND_INVITE_FAIL";
export const SYNC_CALENDER_DEFAULT_ACTION_SUCCESS =
  "SYNC_CALENDER_DEFAULT_ACTION_SUCCESS";
export const SYNC_CALENDER_DEFAULT_ACTION_FAIL =
  "SYNC_CALENDER_DEFAULT_ACTION_FAIL";
export const GET_HANDBOOK_SUCCESS = "GET_HANDBOOK_SUCCESS";
export const GET_HANDBOOK_FAIL = "GET_HANDBOOK_FAIL";
export const POST_HANDBOOK_SUCCESS = "POST_HANDBOOK_SUCCESS";
export const POST_HANDBOOK_FAIL = "POST_HANDBOOK_FAIL";
export const UPDATE_HANDBOOK_SUCCESS = "POST_HANDBOOK_SUCCESS";
export const UPDATE_HANDBOOK_FAIL = "POST_HANDBOOK_FAIL";
export const DELETE_HANDBOOK_SUCCESS = "DELETE_HANDBOOK_SUCCESS";
export const DELETE_HANDBOOK_FAIL = "DELETE_HANDBOOK_FAIL";
export const GET_STRIPE_SUBSCRIPTION_PLANS_SUCCESS =
  "GET_STRIPE_SUBSCRIPTION_PLANS_SUCCESS";
export const GET_STRIPE_SUBSCRIPTION_PLANS_FAIL =
  "GET_STRIPE_SUBSCRIPTION_PLANS_FAIL";

export const ADD_STRIPE_SESSION_SUCCESS = "ADD_STRIPE_SESSION_SUCCESS";
export const ADD_STRIPE_SESSION_FAIL = "ADD_STRIPE_SESSION_FAIL";
export const PRICING_CREATE_SUCCESS = "PRICING_CREATE_SUCCESS";
export const PRICING_CREATE_FAIL = "PRICING_CREATE_FAIL";
export const PRICING_GET_SUCCESS = "PRICING_GET_SUCCESS";
export const PRICING_GET_FAIL = "PRICING_GET_FAIL";
export const PRICING_DASHBOARDGET_SUCCESS = "PRICING_DASHBOARDGET_SUCCESS";
export const PRICING_DASHBOARDGET_FAIL = "PRICING_DASHBOARDGET_FAIL";
export const PRICING_DASHBOARDCANCEL_SUCCESS =
  "PRICING_DASHBOARDCANCEL_SUCCESS";
export const PRICING_DASHBOARDCANCEL_FAIL = "PRICING_DASHBOARDCANCEL_FAIL";
export const PRICING_ADDCARD_SUCCESS = "PRICING_ADDCARD_SUCCESS";
export const PRICING_ADDCARD_FAIL = "PRICING_ADDCARD_FAIL";
export const DEFAULT_PRICING_GET_SUCCESS = "DEFAULT_PRICING_GET_SUCCESS";
export const DEFAULT_PRICING_GET_FAIL = "DEFAULT_PRICING_GET_FAIL";
export const CULTURALFITFETCHSUCCESS = "CULTURALFITFETCHSUCCESS";
export const CULTURALFITFETCHFAIL = "CULTURALFITFETCHFAIL";
export const CULTURALFITSURVEYDELETESUCCESS = "CULTURALFITSURVEYDELETESUCCESS";
export const CULTURALFITSURVEYDELETEFAIL = "CULTURALFITSURVEYDELETEFAIL";
export const CULTURALFITSURVEYCREATESUCCESS = "CULTURALFITSURVEYCREATESUCCESS";
export const CULTURALFITSURVEYCREATEFAIL = "CULTURALFITSURVEYCREATEFAIL";
export const CULTURALFITCHOOSESUCCESS = "CULTURALFITCHOOSESUCCESS";
export const CULTURALFITCHOOSEFAIL = "CULTURALFITCHOOSEFAIL";
export const CULTURALFITQUSPOSTSUCCESS = "CULTURALFITQUSPOSTSUCCESS";
export const CULTURALFITQUSPOSTFAIL = "CULTURALFITQUSPOSTFAIL";
export const CULTURALFITQUSCONFIGSUCCESS = "CULTURALFITQUSCONFIGSUCCESS";
export const CULTURALFITQUSCONFIGFAIL = "CULTURALFITQUSCONFIGFAIL";
export const CULTURALFITQUSCONFIGUPDATESUCCESS =
  "CULTURALFITQUSCONFIGUPDATESUCCESS";
export const CULTURALFITQUSCONFIGUPDATEFAIL = "CULTURALFITQUSCONFIGUPDATEFAIL";
export const CULTURALFITSURVEYADVANCESUCCESS =
  "CULTURALFITSURVEYADVANCESUCCESS";
export const CULTURALFITSURVEYADVANCEFAIL = "CULTURALFITSURVEYADVANCEFAIL";
export const CULTURALFITCATEGORYFETCHSUCCESS =
  "CULTURALFITCATEGORYFETCHSUCCESS";
export const CULTURALFITCATEGORYFETCHFAIL = "CULTURALFITCATEGORYFETCHFAIL";
export const CULTURAL_CREATE_CATEGORY_REQUEST =
  "CULTURAL_CREATE_CATEGORY_REQUEST";

export const CULTURALPRETEMSUCCESS = "CULTURALPRETEMSUCCESS";
export const CULTURALPRETEMFAIL = "CULTURALPRETEMFAIL";

export const CULTURALPRETEMEDITSUCCESS = "CULTURALPRETEMEDITSUCCESS";
export const CULTURALPRETEMEDITFAIL = "CULTURALPRETEMEDITFAIL";
export const CULTURALPRETEMPOSTSUCCESS = "CULTURALPRETEMPOSTSUCCESS";
export const CULTURALPRETEMPOSTFAIL = "CULTURALPRETEMPOSTFAIL";

export const CULTURAL_CREATE_CATEGORY_SUCCESS =
  "CULTURAL_CREATE_CATEGORY_SUCCESS";
export const CULTURAL_CREATE_CATEGORY_FAIL = "CULTURAL_CREATE_CATEGORY_FAIL";
export const CULTURAL_EDIT_CATEGORY_REQUEST = "CULTURAL_EDIT_CATEGORY_REQUEST";
export const CULTURAL_EDIT_CATEGORY_SUCCESS = "CULTURAL_EDIT_CATEGORY_SUCCESS";
export const CULTURAL_EDIT_CATEGORY_FAIL = "CULTURAL_EDIT_CATEGORY_FAIL";
export const CULTURAL_DELETE_CATEGORY_SUCCESS =
  "CULTURAL_DELETE_CATEGORY_SUCCESS";

export const CULTURAL_DELETE_CATEGORY_FAIL = "CULTURAL_DELETE_CATEGORY_FAIL";
export const SOCIAL_LOGIN_SUCCESS = "SOCIAL_LOGIN_SUCCESS";
export const SOCIAL_LOGIN_FAIL = "SOCIAL_LOGIN_FAIL";
export const SSO_LOGIN_URL_SUCCESS = "SSO_LOGIN_URL_SUCCESS";
export const SSO_LOGIN_URL_FAIL = "SSO_LOGIN_URL_FAIL";
export const SSO_LOGOUT_SUCCESS = "SSO_LOGOUT_SUCCESS";
export const SSO_LOGOUT_FAIL = "SSO_LOGOUT_FAIL";
export const SOCIAL_SSO_LOGIN_SUCCESS = "SOCIAL_SSO_LOGIN_SUCCESS";
export const SOCIAL_SSO_LOGIN_FAIL = "SOCIAL_SSO_LOGIN_FAIL";
export const GET_USER_DYNAMIC_FIELD_SUCCESS = "GET_USER_DYNAMIC_FIELD_SUCCESS";
export const GET_USER_DYNAMIC_FIELD_FAIL = "GET_USER_DYNAMIC_FIELD_FAIL";
export const SSO_REFRESH_SUCCESS = "SSO_REFRESH_SUCCESS";
export const SSO_REFRESH_FAIL = "SSO_REFRESH_FAIL";
export const CULTURALFITQUSCONFIGGETSUCCESS = "CULTURALFITQUSCONFIGGETSUCCESS";
export const CULTURALFITQUSCONFIGGETFAIL = "CULTURALFITQUSCONFIGGETFAIL";
export const CULTURAL_CREATE_SUB_CATEGORY_REQUEST =
  "CULTURAL_CREATE_SUB_CATEGORY_REQUEST";
export const CULTURAL_CREATE_SUB_CATEGORY_SUCCESS =
  "CULTURAL_CREATE_SUB_CATEGORY_SUCCESS";
export const CULTURAL_CREATE_SUB_CATEGORY_FAIL =
  "CULTURAL_CREATE_SUB_CATEGORY_FAIL";
export const CULTURAL_EDIT_SUB_CATEGORY_REQUEST =
  "CULTURAL_EDIT_SUB_CATEGORY_REQUEST";
export const CULTURAL_EDIT_SUB_CATEGORY_SUCCESS =
  "CULTURAL_EDIT_SUB_CATEGORY_SUCCESS";
export const CULTURAL_EDIT_SUB_CATEGORY_FAIL =
  "CULTURAL_EDIT_SUB_CATEGORY_FAIL";
export const CULTURAL_DELETE_SUB_CATEGORY_SUCCESS =
  "CULTURAL_DELETE_SUB_CATEGORY_SUCCESS";
export const CULTURAL_DELETE_SUB_CATEGORY_FAIL =
  "CULTURAL_DELETE_SUB_CATEGORY_FAIL";
export const SEARCH_CATEGORY_SUBCATEGORY_FETCH_SUCCESS =
  "SEARCH_CATEGORY_SUBCATEGORY_FETCH_SUCCESS";
export const SEARCH_CATEGORY_SUBCATEGORY_FETCH_FAIL =
  "SEARCH_CATEGORY_SUBCATEGORY_FETCH_FAIL";
export const CULTURALFITSURVEYASSIGNEESUCCESS =
  "CULTURALFITSURVEYASSIGNEESUCCESS";
export const CULTURALFITSURVEYASSIGNEEFAIL = "CULTURALFITSURVEYASSIGNEEFAIL";
export const USER_CULTURE_ALIGN_FETCH_SUCCESS =
  "USER_CULTURE_ALIGN_FETCH_SUCCESS";
export const USER_CULTURE_ALIGN_FETCH_FAIL = "USER_CULTURE_ALIGN_FETCH_FAIL";
export const USER_CULTURE_ALIGN_GET_BY_ID_REQUEST =
  "USER_CULTURE_ALIGN_GET_BY_ID_REQUEST";
export const USER_CULTURE_ALIGN_GET_BY_ID_SUCCESS =
  "USER_CULTURE_ALIGN_GET_BY_ID_SUCCESS";
export const USER_CULTURE_ALIGN_GET_BY_ID_FAIL =
  "USER_CULTURE_ALIGN_GET_BY_ID_FAIL";
export const CULTURALFITUSERPOSTSUCCESS = "CULTURALFITUSERPOSTSUCCESS";
export const CULTURALFITUSERPOSTFAIL = "CULTURALFITUSERPOSTFAIL";
export const CULTURALFIT_SUBCATEGORY_FETCHSUCCESS =
  "CULTURALFIT_SUBCATEGORY_FETCHSUCCESS";
export const CULTURALFIT_SUBCATEGORY_FETCHFAIL =
  "CULTURALFIT_SUBCATEGORY_FETCHFAIL";
export const REPORT_SURVEYLIST_FETCH_SUCCESS =
  "REPORT_SURVEYLIST_FETCH_SUCCESS";
export const REPORT_SURVEYLIST_FETCH_FAIL = "REPORT_SURVEYLIST_FETCH_FAIL";
export const CULTURAL_ALIGN_REPORT_LIST_SUCCESS =
  "CULTURAL_ALIGN_REPORT_LIST_SUCCESS";
export const CULTURAL_ALIGN_REPORT_LIST_FAIL =
  "CULTURAL_ALIGN_REPORT_LIST_FAIL";
export const SURVEY_ASSIGNEE_BY_SURVEYID_SUCCESS =
  "SURVEY_ASSIGNEE_BY_SURVEYID_SUCCESS";
export const SURVEY_ASSIGNEE_BY_SURVEYID_FAIL =
  "SURVEY_ASSIGNEE_BY_SURVEYID_FAIL";
export const SURVEY_BY_SURVEY_ID_SUCCESS = "SURVEY_BY_SURVEY_ID_SUCCESS";
export const SURVEY_BY_SURVEY_ID_FAIL = "SURVEY_BY_SURVEY_ID_FAIL";
export const GET_MENTION_MEMBERS_SERVICE_SUCCESS =
  "GET_MENTION_MEMBERS_SERVICE_SUCCESS";
export const GET_MENTION_MEMBERS_SERVICE_FAIL =
  "GET_MENTION_MEMBERS_SERVICE_FAIL";
export const GETALL_APPROVERSLIST_SUCCESS = "GETALL_APPROVERSLIST_SUCCESS";
export const GETALL_APPROVERSLIST_FAIL = "GETALL_APPROVERSLIST_FAIL";
export const CIF_PERIODIC_ASSESSMENT_CONFIG_SUCCESS =
  "CIF_PERIODIC_ASSESSMENT_CONFIG_SUCCESS";
export const CIF_PERIODIC_ASSESSMENT_CONFIG_FAIL =
  "CIF_PERIODIC_ASSESSMENT_CONFIG_FAIL";
export const SURVEY_CHART_SUCCESS = "SURVEY_CHART_SUCCESS";
export const SURVEY_CHART_FAIL = "SURVEY_CHART_FAIL";
export const SURVEY_CHART_ALL_PERIOD_SUCCESS =
  "SURVEY_CHART_ALL_PERIOD_SUCCESS";
export const SURVEY_CHART_ALL_PERIOD_FAIL = "SURVEY_CHART_ALL_PERIOD_FAIL";
export const SURVEY_UPDATE_QUESTION_DELETE_SUCCESS =
  "SURVEY_UPDATE_QUESTION_DELETE_SUCCESS";
export const SURVEY_UPDATE_QUESTION_DELETE_FAIL =
  "SURVEY_UPDATE_QUESTION_DELETE_FAIL";
export const SURVEY_UPDATE_QUESTION_OPTION_DELETE_SUCCESS =
  "SURVEY_UPDATE_QUESTION_OPTION_DELETE_SUCCESS";
export const SURVEY_UPDATE_QUESTION_OPTION_DELETE_FAIL =
  "SURVEY_UPDATE_QUESTION_OPTION_DELETE_FAIL";
export const SURVEY_ASSESSMENT_APPROVAL_SUCCESS =
  "SURVEY_ASSESSMENT_APPROVAL_SUCCESS";
export const SURVEY_ASSESSMENT_APPROVAL_FAIL =
  "SURVEY_ASSESSMENT_APPROVAL_FAIL";
export const SURVEY_ASSIGNEE_DELIVERY_SUCCESS =
  "SURVEY_ASSIGNEE_DELIVERY_SUCCESS";
export const SURVEY_ASSIGNEE_DELIVERY_FAIL = "SURVEY_ASSIGNEE_DELIVERY_FAIL";
export const SURVEY_ASSIGNEE_APPROVAL_SUCCESS =
  "SURVEY_ASSIGNEE_APPROVAL_SUCCESS";
export const SURVEY_ASSIGNEE_APPROVAL_FAIL = "SURVEY_ASSIGNEE_APPROVAL_FAIL";
export const SURVEY_ASSIGNEE_ANSAPPROVAL_SUCCESS =
  "SURVEY_ASSIGNEE_ANSAPPROVAL_SUCCESS";
export const SURVEY_ASSIGNEE_ANSAPPROVAL_FAIL =
  "SURVEY_ASSIGNEE_ANSAPPROVAL_FAIL";

export const CREATE_HELPDESK_SUCCESS = "CREATE_HELPDESK_SUCCESS";
export const CREATE_HELPDESK_FAIL = "CREATE_HELPDESK_FAIL";
export const GET_HELPDESK_DROPDOWNLIST_SUCCESS =
  "GET_HELPDESK_DROPDOWNLIST_SUCCESS";
export const GET_HELPDESK_DROPDOWNLIST_FAIL = "GET_HELPDESK_DROPDOWNLIST_FAIL";
export const GET_HELPDESK_SUCCESS = "GET_HELPDESK_SUCCESS";
export const GET_HELPDESK_FAIL = "GET_HELPDESK_FAIL";
export const DELETE_HELPDESK_SUCCESS = "DELETE_HELPDESK_SUCCESS";
export const DELETE_HELPDESK_FAIL = "DELETE_HELPDESK_FAIL";
export const UPDATE_HELPDESK_SUCCESS = "DELETE_HELPDESK_SUCCESS";
export const UPDATE_HELPDESK_FAIL = "DELETE_HELPDESK_FAIL";
export const GETCHATSESSION_SUCCESS = "GETCHATSESSION_SUCCESS";
export const GETCHATSESSION_FAIL = "GETCHATSESSION_FAIL";
export const GETCUSTOMCHATSESSION_SUCCESS = "GETCUSTOMCHATSESSION_SUCCESS";
export const GETCUSTOMCHATSESSION_FAIL = "GETCUSTOMCHATSESSION_FAIL";
export const PUBLISH_STRATEGY_SUCCESS = "PUBLISH_STRATEGY_SUCCESS";
export const PUBLISH_STRATEGY_FAIL = "PUBLISH_STRATEGY_FAIL";
export const EDIT_STRATEGY_SUCCESS = "EDIT_STRATEGY_SUCCESS";
export const EDIT_STRATEGY_FAIL = "EDIT_STRATEGY_FAIL";
export const CIF_CONVERSATIONWITH_SUCCESS = "CIF_CONVERSATIONWITH_SUCCESS";
export const CIF_CONVERSATIONWITH_FAIL = "CIF_CONVERSATIONWITH_FAIL";
export const CIF_CONVERSATIONFILTER_SUCCESS = "CIF_CONVERSATIONFILTER_SUCCESS";
export const CIF_CONVERSATIONFILTER_FAIL = "CIF_CONVERSATIONFILTER_FAIL";
export const CIF_BASICWITHOUTAPPROVAL_SUCCESS =
  "CIF_BASICWITHOUTAPPROVAL_SUCCESS";
export const CIF_BASICWITHOUTAPPROVAL_FAIL = "CIF_BASICWITHOUTAPPROVAL_FAIL";

export const GET_ORGANIZATION_SUBSCRIPTION_DETAIL_SUCCESS =
  "GET_ORGANIZATION_SUBSCRIPTION_DETAIL_SUCCESS";
export const GET_ORGANIZATION_SUBSCRIPTION_DETAIL_FAIL =
  "GET_ORGANIZATION_SUBSCRIPTION_DETAIL_FAIL";
export const UPDATE_ORGANIZATION_SUBSCRIPTION_DETAIL_SUCCESS =
  "UPDATE_ORGANIZATION_SUBSCRIPTION_DETAIL_SUCCESS";
export const UPDATE_ORGANIZATION_SUBSCRIPTION_DETAIL_FAIL =
  "UPDATE_ORGANIZATION_SUBSCRIPTION_DETAIL_FAIL";

export const GET_WORKSPACE_MONDAY_SUCCESS = "GET_WORKSPACE_MONDAY_SUCCESS";
export const GET_WORKSPACE_MONDAY_FAIL = "GET_WORKSPACE_MONDAY_FAIL";
export const GET_WORKSPACE_BOARD_SUCCESS = "GET_WORKSPACE_BOARD_SUCCESS";
export const GET_WORKSPACE_BOARD_FAILS = "GET_WORKSPACE_BOARD_FAILS";
export const GET_WORKSPACE_BOARD_FILTER_SUCCESS =
  "GET_WORKSPACE_BOARD_FILTER_SUCCESS";
export const GET_WORKSPACE_BOARD_FILTER_FAILS =
  "GET_WORKSPACE_BOARD_FILTER_FAILS";
export const SUBMIT_CRM_FILTERS_SUCCESS = "SUBMIT_CRM_FILTERS_SUCCESS";
export const SUBMIT_CRM_FILTERS_FAILS = "SUBMIT_CRM_FILTERS_FAILS";
export const USER_LIST_DETAILS_SUCCESS = "USER_LIST_DETAILS_SUCCESS";
export const USER_LIST_DETAILS_FAILS = "USER_LIST_DETAILS_FAILS";
export const CREATE_TODOS_SUCCESS = "CREATE_TODOS_SUCCESS";
export const CREATE_TODOS_FAIL = "CREATE_TODOS_FAIL";
export const UPDATE_TODOS_SUCCESS = "UPDATE_TODOS_SUCCESS";
export const UPDATE_TODOS_FAIL = "UPDATE_TODOS_FAIL";
export const UPDATE_TODOS_PROGRESS_SUCCESS = "UPDATE_TODOS_PROGRESS_SUCCESS";
export const UPDATE_TODOS_PROGRESS_FAIL = "UPDATE_TODOS_PROGRESS_FAIL";
export const DELETE_TODOS_SUCCESS = "DELETE_TODOS_SUCCESS";
export const DELETE_TODOS_FAIL = "DELETE_TODOS_FAIL";
export const GET_TODOS_SUCCESS = "GET_TODOS_SUCCESS";
export const GET_TODOS_FAIL = "GET_TODOS_FAIL";
export const BULK_EDIT_TODOS_SUCCESS = "BULK_EDIT_TODOS_SUCCESS";
export const BULK_EDIT_TODOS_FAIL = "BULK_EDIT_TODOS_FAIL";
export const GETSESSION_KEYRESULTDASHBOARD_SUCCESS =
  "GETSESSION_KEYRESULTDASHBOARD_SUCCESS";
export const GETSESSION_KEYRESULTDASHBOARD_FAIL =
  "GETSESSION_KEYRESULTDASHBOARD_FAIL";
export const GET_HUBSPOT_DATA_SUCCESS = "GET_HUBSPOT_OBJECT_PROPERTIES_SUCCESS";
export const GET_HUBSPOT_DATA_FAILS = "GET_HUBSPOT_OBJECT_PROPERTIES_FAILS";
export const SAVE_HUBSPOT_DATA_SUCCESS = "SAVE_HUBSPOT_DATA_SUCCESS";
export const SAVE_HUBSPOT_DATA_FAILS = "SAVE_HUBSPOT_DATA_FAILS";
export const GET_TIMEOFF_DASHBOARD_DATA_SUCCESS =
  "GET_TIMEOFF_DASHBOARD_DATA_SUCCESS";
export const GET_TIMEOFF_DASHBOARD_DATA_FAILS =
  "GET_TIMEOFF_DASHBOARD_DATA_FAILS";
export const GET_EXPENSEDASHBOARD_DATA_SUCCESS =
  "GET_EXPENSEDASHBOARD_DATA_SUCCESS";
export const GET_EXPENSEDASHBOARD_DATA_FAILS =
  "GET_EXPENSEDASHBOARD_DATA_FAILS";
export const GET_DASHBOARD_TIMESHEET_DATA_SUCCESS =
  "GET_DASHBOARD_TIMESHEET_DATA_SUCCESS";
export const GET_DASHBOARD_TIMESHEET_DATA_FAILS =
  "GET_DASHBOARD_TIMESHEET_DATA_FAILS";
export const INVITE_MEMBER_LINK_SUCCESS = "INVITE_MEMBER_LINK_SUCCESS";
export const INVITE_MEMBER_LINK_FAIL = "INVITE_MEMBER_LINK_FAIL";
export const CIF_ADVANCE_CONVERSATIONWITH_SUCCESS =
  "CIF_ADVANCE_CONVERSATIONWITH_SUCCESS";
export const CIF_ADVANCE_CONVERSATIONWITH_FAIL =
  "CIF_ADVANCE_CONVERSATIONWITH_FAIL";
export const GET_CALENDAR_TIMESHEET_FILTER_SUCCESS =
  "GET_CALENDAR_TIMESHEET_FILTER_SUCCESS";
export const GET_CALENDAR_TIMESHEET_FILTER_FAIL =
  "GET_CALENDAR_TIMESHEET_FILTER_FAIL";

export const GET_ALLROLE_PERMISSIONS_SUCCESS =
  "GET_ALLROLE_PERMISSIONS_SUCCESS";
export const GET_ALLROLE_PERMISSIONS_FAIL = "GET_ALLROLE_PERMISSIONS_FAIL";

export const GET_ROLETYPE_PERMISSION_SUCCESS =
  "GET_ROLETYPE_PERMISSION_SUCCESS";
export const GET_ROLETYPE_PERMISSION_FAIL = "GET_ROLETYPE_PERMISSION_FAIL";

export const GET_ALL_CUSTOM_ROLE_SUCCESS = "GET_ALL_CUSTOM_ROLE_SUCCESS";
export const GET_ALL_CUSTOM_ROLE_FAIL = "GET_ALL_CUSTOM_ROLE_FAIL";

export const DELETE_ALL_CUSTOM_ROLE_SUCCESS = "DELETE_ALL_CUSTOM_ROLE_SUCCESS";
export const DELETE_ALL_CUSTOM_ROLE_FAIL = "DELETE_ALL_CUSTOM_ROLE_FAIL";

export const GET_ROLE_BASE_PERMISSIONS_SUCCESS =
  "GET_ROLE_BASE_PERMISSIONS_SUCCESS";
export const GET_ROLE_BASE_PERMISSIONS_FAIL = "GET_ROLE_BASE_PERMISSIONS_FAIL";

export const CREATE_CUSTOM_ROLE_SUCCESS = "CREATE_CUSTOM_ROLE_SUCCESS";
export const CREATE_CUSTOM_ROLE_FAIL = "CREATE_CUSTOM_ROLE_FAIL";

export const GENERATE_WORKSPACE_API_KEY_SUCCESS =
  "GENERATE_WORKSPACE_API_KEY_SUCCESS";
export const GENERATE_WORKSPACE_API_KEY_FAIL =
  "GENERATE_WORKSPACE_API_KEY_FAIL";

export const GET_WORKSPACE_API_KEY_SUCCESS = "GET_WORKSPACE_API_KEY_SUCCESS";
export const GET_WORKSPACE_API_KEY_FAIL = "GET_WORKSPACE_API_KEY_FAIL";

export const UPDATE_ROLETYPE_PERMISSION_SUCCESS =
  "UPDATE_ROLETYPE_PERMISSION_SUCCESS";
export const UPDATE_ROLETYPE_PERMISSION_FAIL =
  "UPDATE_ROLETYPE_PERMISSION_FAIL";
export const GET_PERMISSION_DASHBOARD_SUCCESS =
  "GET_PERMISSION_DASHBOARD_SUCCESS";
export const GET_PERMISSION_DASHBOARD_FAIL = "GET_PERMISSION_DASHBOARD_FAIL";
export const GET_MY_TICKETS_SUCCESS = "GET_MY_TICKETS_SUCCESS";
export const GET_MY_TICKETS_FAIL = "GET_MY_TICKETS_FAIL";
export const GETRESPONSE_TICKETS_SUCCESS = "GETRESPONSE_TICKETS_SUCCESS";
export const GETRESPONSE_TICKETS_FAIL = "GETRESPONSE_TICKETS_FAIL";
export const GETWORKSPACE_CONTRACTOR_OWNERS_SUCCESS =
  "GETWORKSPACE_CONTRACTOR_OWNERS_SUCCESS";
export const GETWORKSPACE_CONTRACTOR_OWNERS_FAIL =
  "GETWORKSPACE_CONTRACTOR_OWNERS_FAIL";

export const GET_PERMISSION_DASHBOARD_CONTRACTOR_SUCCESS =
  "GET_PERMISSION_DASHBOARD_CONTRACTOR_SUCCESS";

export const GET_PERMISSION_DASHBOARD_CONTRACTOR_FAIL =
  "GET_PERMISSION_DASHBOARD_CONTRACTOR_FAIL";
export const GET_TICKET_COMMENT_SUCCESS = "GET_TICKET_COMMENT_SUCCESS";
export const GET_TICKET_COMMENT_FAIL = "GET_TICKET_COMMENT_FAIL";
export const CREATE_TICKET_COMMENT_SUCCESS = "CREATE_TICKET_COMMENT_SUCCESS";
export const CREATE_TICKET_COMMENT_FAIL = "CREATE_TICKET_COMMENT_FAIL";
export const UPDATE_TICKET_COMMENT_SUCCESS = "UPDATE_TICKET_COMMENT_SUCCESS";
export const UPDATE_TICKET_COMMENT_FAIL = "UPDATE_TICKET_COMMENT_FAIL";
export const DELETE_TICKET_COMMENT_SUCCESS = "DELETE_TICKET_COMMENT_SUCCESS";
export const DELETE_TICKET_COMMENT_FAIL = "DELETE_TICKET_COMMENT_FAIL";
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS";
export const GET_CATEGORY_FAIL = "GET_CATEGORY_FAIL";
export const CREATE_CATEGORY_SUCCESS = "CREATE_CATEGORY_SUCCESS";
export const CREATE_CATEGORY_FAIL = "CREATE_CATEGORY_FAIL";
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_FAIL = "UPDATE_CATEGORY_FAIL";
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_FAIL = "DELETE_CATEGORY_FAIL";

export const CULTUREOKR_TEMPLATE_SUCCESS = "CULTUREOKR_TEMPLATE_SUCCESS";
export const CULTUREOKR_TEMPLATE_FAIL = "CULTUREOKR_TEMPLATE_FAIL";
export const GET_WORKSPACE_AIVIO_SUCCESS = "GET_WORKSPACE_AIVIO_SUCCESS";
export const GET_WORKSPACE_AIVIO_FAIL = "GET_WORKSPACE_AIVIO_FAIL";
export const GET_BOARDS_AIVIO_SUCCESS = "GET_BOARDS_AIVIO_SUCCESS";
export const GET_BOARDS_AIVIO_FAIL = "GET_BOARDS_AIVIO_FAIL";
export const GET_FILTER_AIVIO_SUCCESS = "GET_FILTER_AIVIO_SUCCESS";
export const GET_FILTER_AIVIO_FAIL = "GET_FILTER_AIVIO_FAIL";
export const GET_FILTER_VALUE_AIVIO_SUCCESS = "GET_FILTER_VALUE_AIVIO_SUCCESS";
export const GET_FILTER_VALUE_AIVIO_FAIL = "GET_FILTER_VALUE_AIVIO_FAIL";
export const SUMBIT_FILTERS_AIVIO_SUCCESS = "SUMBIT_FILTERS_AIVIO_SUCCESS";
export const SUMBIT_FILTERS_AIVIO_FAILS = "SUMBIT_FILTERS_AIVIO_FAILS";
export const GET_OWNERS_AIVIO_SUCCESS = "GET_OWNERS_AIVIO_SUCCESS";
export const GET_OWNERS_AIVIO_FAIL = "GET_OWNERS_AIVIO_FAIL";
export const SURVEY_SUMITTED_CHECK_SUCCESS = "SURVEY_SUMITTED_CHECK_SUCCESS";
export const SURVEY_SUMITTED_CHECK_FAIL = "SURVEY_SUMITTED_CHECK_FAIL";
export const SUBMIT_CONNECTOR_SYNC_SUCCESS = "SUBMIT_CONNECTOR_SYNC_SUCCESS";
export const SUBMIT_CONNECTOR_SYNC_FAILS = "SUBMIT_CONNECTOR_SYNC_FAILS";
export const PRICING_CHANGE_HISTORY_SUCCESS = "PRICING_CHANGE_HISTORY_SUCCESS";
export const PRICING_CHANGE_HISTORY_FAIL = "PRICING_CHANGE_HISTORY_FAIL";
export const SUPERADMIN_PRICING_UPDATE_SUCCESS =
  "SUPERADMIN_PRICING_UPDATE_SUCCESS";
export const SUPERADMIN_PRICING_UPDATE_FAIL = "SUPERADMIN_PRICING_UPDATE_FAIL";
export const GET_SUPERADMIN_PRICING_SUCCESS = "GET_SUPERADMIN_PRICING_SUCCESS";
export const GET_SUPERADMIN_PRICING_FAIL = "GET_SUPERADMIN_PRICING_FAIL";
export const GET_SUPERADMIN_CUSTOMERS_SUCCESS =
  "GET_SUPERADMIN_CUSTOMERS_SUCCESS";
export const GET_SUPERADMIN_CUSTOMERS_FAIL = "GET_SUPERADMIN_CUSTOMERS_FAIL";
export const GET_SUPERADMIN_CUSTOMER_WORKSPACES_SUCCESS =
  "GET_SUPERADMIN_CUSTOMER_WORKSPACES_SUCCESS";
export const GET_SUPERADMIN_CUSTOMER_WORKSPACES_FAIL =
  "GET_SUPERADMIN_CUSTOMER_WORKSPACES_FAIL";
export const RETRIEVE_PLAN_SUCCESS = "RETRIEVE_PLAN_SUCCESS";
export const RETRIEVE_PLAN_FAIL = "RETRIEVE_PLAN_FAIL";
export const RETRIEVE_PLAN_PRICING_SUCCESS = "RETRIEVE_PLAN_PRICING_SUCCESS";
export const RETRIEVE_PLAN_PRICING_FAIL = "RETRIEVE_PLAN_PRICING_FAIL";
export const CREATE_PLAN_PRICE_SUCCESS = "CREATE_PLAN_PRICE_SUCCESS";
export const CREATE_PLAN_PRICE_FAIL = "CREATE_PLAN_PRICE_FAIL";
export const UPDATE_PLAN_PRICE_SUCCESS = "UPDATE_PLAN_PRICE_SUCCESS";
export const UPDATE_PLAN_PRICE_FAIL = "UPDATE_PLAN_PRICE_FAIL";
export const DELETE_PLAN_PRICE_SUCCESS = "DELETE_PLAN_PRICE_SUCCESS";
export const DELETE_PLAN_PRICE_FAIL = "DELETE_PLAN_PRICE_FAIL";
export const UPDATE_CUSTOMER_SUBSCRIPTION_SUCCESS =
  "UPDATE_CUSTOMER_SUBSCRIPTION_SUCCESS";
export const UPDATE_CUSTOMER_SUBSCRIPTION_FAIL =
  "UPDATE_CUSTOMER_SUBSCRIPTION_FAIL";

export const UPDATE_SUPERADMIN_PLAN_SUCCESS = "UPDATE_SUPERADMIN_PLAN_SUCCESS";
export const UPDATE_SUPERADMIN_PLAN_FAIL = "UPDATE_SUPERADMIN_PLAN_FAIL";
export const CREATE_SUB_CATEGORY_SUCCESS = "CREATE_SUB_CATEGORY_SUCCESS";
export const CREATE_SUB_CATEGORY_FAIL = "CREATE_SUB_CATEGORY_FAIL";
export const UPDATE_SUBCATEGORY_SUCCESS = "UPDATE_SUBCATEGORY_SUCCESS";
export const UPDATE_SUBCATEGORY_FAIL = "UPDATE_SUBCATEGORY_FAIL";
export const DELETE_SUBCATEGORY_SUCCESS = "DELETE_SUBCATEGORY_SUCCESS";
export const DELETE_SUBCATEGORY_FAIL = "DELETE_SUBCATEGORY_FAIL";
export const UPDATE_TODOS_IMPORTANT_SUCCESS = "UPDATE_TODOS_IMPORTANT_SUCCESS";
export const UPDATE_TODOS_IMPORTANT_FAIL = "UPDATE_TODOS_IMPORTANT_FAIL";
export const CREATE_TODO_TAGS_SUCCESS = "CREATE_TODO_TAGS_SUCCESS";
export const CREATE_TODO_TAGS_FAIL = "CREATE_TODO_TAGS_FAIL";
export const DELETE_TODO_TAGS_SUCCESS = "DELETE_TODO_TAGS_SUCCESS";
export const DELETE_TODO_TAGS_FAIL = "DELETE_TODO_TAGS_FAIL";
export const GET_TODO_TAGS_SUCCESS = "GET_TODO_TAGS_SUCCESS";
export const GET_TODO_TAGS_FAIL = "GET_TODO_TAGS_FAIL";
export const UPDATE_TODO_TAGS_SUCCESS = "UPDATE_TODO_TAGS_SUCCESS";
export const UPDATE_TODO_TAGS_FAIL = "UPDATE_TODO_TAGS_FAIL";
export const ASSIGN_TODOS_SUCCESS= "ASSIGN_TODOS_SUCCESS";
export const ASSIGN_TODOS_FAIL = "ASSIGN_TODOS_FAIL";